export const JWT = "jwt";
export const USER = "user";

// 根据环境获取api
export const baseUrl = process.env.VUE_APP_BASE_API;

// 保存token
export function setJWT(jwt) {
  let startTime = new Date().getTime(); //记录何时将值存入缓存，毫秒级

  localStorage.setItem(JWT, `${jwt}+,+${startTime}`);
}

// 获取token
export function getJWT() {
  let arr = localStorage.getItem(JWT);

  if (arr) return arr.split("+,+")[0];
  else return null;
}

// 获取保存token的时间戳
export function getJWTTime() {
  let arr = localStorage.getItem(JWT);

  if (arr) return parseInt(arr.split("+,+")[1]);
  else return null;
}

// 保存用户信息
export function setUSER(user) {
  localStorage.setItem(USER, JSON.stringify(user));
}

// 获取用户信息
export function getUSER() {
  let user = localStorage.getItem(USER);
  return JSON.parse(user);
}
// 消除用户信息
export function removeUSER() {
  localStorage.clear();
}